import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatOptionSelectAllModule } from './mat-option-select-all/mat-option-select-all.module';
import { MaterialModule } from './material.module';

@NgModule({
  imports: [FormsModule, MaterialModule, CommonModule, ReactiveFormsModule, MatOptionSelectAllModule],
  declarations: [],
  exports: [FormsModule, MaterialModule, CommonModule, ReactiveFormsModule, MatOptionSelectAllModule],
})
export class SharedModule {}
